import { UtilityService } from './../utility.service';
import { AuthorizationService } from './authorization.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DialogDataComponent } from './../dialog-data/dialog-data.component';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
export interface PeriodicElement {
  providerInfo: string;
  Specialty: string;
  address: string;
  // patientaddress:string;
}
const ELEMENT_DATA: PeriodicElement[] = [
  {
    providerInfo: 'HARBORVIEW MEDICAL CENTER , NPI:10234343 ,Tax ID:2946463',
    Specialty: 'Hydrogen',
    address: '325 9th AVE SEATTLE,WA 98104'
  },
  {
    providerInfo: 'HARBORVIEW MEDICAL CENTER , NPI:10234343 ,Tax ID:2946463',
    Specialty: 'Helium',
    address: '325 9th AVE SEATTLE,WA 98104'
  },
  {
    providerInfo: 'HARBORVIEW MEDICAL CENTER , NPI:10234343 ,Tax ID:2946463',
    Specialty: 'Lithium',
    address: '325 9th AVE SEATTLE,WA 98104'
  }
];

@Component({
  selector: 'app-authorization',
  templateUrl: './authorization.component.html',
  styleUrls: ['./authorization.component.scss'],
  providers: [AuthorizationService]
})
export class AuthorizationComponent implements OnInit {
  displayedColumns: string[] = [
    'providerInfo',
    'Specialty',
    'address',
    'select'
  ];
  dataSource = ELEMENT_DATA;

  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  coverageInfo: FormGroup;
  memberInfo: FormGroup;
  reqProvider: FormGroup;
  ServiceInfo: FormGroup;
  diagnosis: FormGroup;
  procedureCode: FormGroup;
  AppointmentInfo: FormGroup;
  patientInfo: FormGroup;
  practitionerInfo: FormGroup;
  organisationInfo: FormGroup;
  locationInfo: FormGroup;
  close: boolean = true;
  selectedValues: any = {};
  fileName: any;
  files: [];
  patientId: any;
  practitionerId: any;
  organizationId: any;
  locationId: any;
  procedureId: any;
  conditionId: any;
  appointmentId: any;
  coverageId: any;
  coverageEligibilityRequestId: any;
  subscriberId: number;
  coverageEligibityRequestData: any;
  coding: any = [];
  coding1: any = [];
  procedureCode1: any[];
  EthnicityObj: any;
  raceObj: any;
  Urlconstent: any = 'http://hl7.org/fhir/StructureDefinition/';
  extensionObj: any = [];
  procudecodeMainItem: any = [];
  Procedure: any = [
    {
      id: 1,
      Procedurecode: [
        {
          option1: '92941-PRQ CARD REVASC MI 1 VSL',
          type: 'CPT/HCPCS'
        },
        {
          option1: '21010-INCISION OF JAW JOINT',
          type: 'CPT/HCPCS'
        },
        {
          option1: '11000-DEBRIDE INFECTED SKIN',
          type: 'CPT/HCPCS'
        }
      ]
    }
  ];
  ProcedurecodeAddNew: any = [{}];
  Procedurecode: any = [
    {
      option1: '92941-PRQ CARD REVASC MI 1 VSL',
      type: 'CPT/HCPCS'
    },
    {
      option1: '21010-INCISION OF JAW JOINT',
      type: 'CPT/HCPCS'
    },
    {
      option1: '11000-DEBRIDE INFECTED SKIN',
      type: 'CPT/HCPCS'
    }
  ];
  lessdisplay: boolean = false;
  plusdislay: boolean = true;

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    public AuthorizationService: AuthorizationService,
    private toastr: ToastrService,
    private util: UtilityService
  ) {}

  ngOnInit() {
    if (this.Procedure.length == 1) {
      //this.display = true
    }
    this.firstFormGroup = this.fb.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this.fb.group({
      secondCtrl: ['', Validators.required]
    });
    this.coverageInfo = this.fb.group({
      groupId: ['', Validators.required],
      value: ['', Validators.required],
      subId: ['', Validators.required],
      suffix: ['', Validators.required],
      status: ['', Validators.required],
      purpose: ['', Validators.required],
      created: ['', Validators.required]
    });
    this.memberInfo = this.fb.group({
      memberId: ['', Validators.required],
      fname: ['', Validators.required],
      lname: ['', Validators.required],
      dob: ['', Validators.required],
      relSub: ['', Validators.required],
      patientaddress: [],
      city: [],
      state: [],
      postalCode: [],
      race: [],
      ethnicity: []
    });
    this.patientInfo = this.fb.group({
      patientFname: ['', Validators.required],
      patientLname: ['', Validators.required],
      patientDob: ['', Validators.required]
    });

    this.reqProvider = this.fb.group({
      provRole: ['', Validators.required],
      pfirstname: ['', Validators.required],
      plastname: ['', Validators.required],
      npi: ['', Validators.required],
      taxid: ['', Validators.required],
      specialty: ['', Validators.required],
      address: ['', Validators.required],
      fax: ['', Validators.required],
      cname: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      postalCode: ['', Validators.required]
    });
    this.ServiceInfo = this.fb.group({
      ServiceType: ['', Validators.required],
      placeOfSer: ['', Validators.required],
      levelOfCare: ['', Validators.required],
      diagnoCode: ['', Validators.required],
      proCode1: ['', Validators.required],
      proCode2: ['', Validators.required],
      proCode3: ['', Validators.required],
      options: []
    });
    this.AppointmentInfo = this.fb.group({
      addmType: ['', Validators.required],
      addmDate: ['', Validators.required]
    });
    this.practitionerInfo = this.fb.group({
      practitionerState: ['', Validators.required],
      practitionerZip: ['', Validators.required]
    });
    this.organisationInfo = this.fb.group({
      orgPlaceOfSer: ['', Validators.required]
    });
    this.locationInfo = this.fb.group({
      locPlaceOfSer: ['', Validators.required]
    });
    this.diagnosis = this.fb.group({
      diagnoCode: ['', Validators.required]
    });
    this.procedureCode = this.fb.group({
      proCode1: ['', Validators.required],
      proCode2: ['', Validators.required],
      proCode3: ['', Validators.required]
    });
    this.selectedValues = JSON.parse(localStorage.getItem('selectedValues'));
  }

  openDialog() {
    const dialogRef = this.dialog.open(DialogDataComponent, {
      width: '50%',
      data: this.coverageEligibityRequestData
    });
  }

  doSomething(item: any, items: any) {
    console.log(items);
    this.procedureCode1 = [];
    this.procedureCode = item.value.split('-');
    //console.log(this.procedureCode)
    this.coding = [
      {
        system: 'http://snomed.info/sct',
        code: this.procedureCode[0],
        display: this.procedureCode[1]
      }
    ];

    console.log(this.coding1);

    var index = this.coding1.findIndex(itemd => itemd.id === items.id);
    if (index > -1) {
      console.log(' inside side ');
      this.coding1[index].coding = this.coding;
    } else {
      console.log(' out side ');
      this.coding1.push({ id: items.id, coding: this.coding });
    }
    console.log(this.coding1);
    this.procudecodeMainItem = [];
    for (let i = 0; i < this.coding1.length; i++) {
      this.procudecodeMainItem.push(this.coding1[i].coding);
    }
    console.log(this.procudecodeMainItem);
  }

  addNewChoice = function() {
    // this.coding= [
    //   {
    //     system: 'http://snomed.info/sct',
    //     code: this.procedureCode[0],
    //     display: this.procedureCode[1]
    //   }
    // ]

    //  this.coding1.push(this.coding)
    //  console.log(this.coding1)
    this.ProcedurecodeAddNew = [
      {
        option1: '92941-PRQ CARD REVASC MI 1 VSL',
        type: 'CPT/HCPCS'
      },
      {
        option1: '21010-INCISION OF JAW JOINT',
        type: 'CPT/HCPCS'
      },
      {
        option1: '11000-DEBRIDE INFECTED SKIN',
        type: 'CPT/HCPCS'
      }
    ];

    var newItemNo = this.Procedure.length + 1;

    this.Procedure.push({
      id: this.Procedure.length + 1,
      Procedurecode: this.Procedurecode
    });
    console.log(this.Procedure);
    if (this.Procedure.length >= 1) {
      this.lessdisplay = true;
    }
  };

  removeChoice = function() {
    if (this.Procedure.length > 0) {
      var lastItem = this.Procedure.length - 1;
      this.Procedure.splice(lastItem);
    }
    console.log(this.Procedure.length);
    if (this.Procedure.length == 1) {
      this.lessdisplay = false;
    }
  };

  closeClick() {
    this.close = false;
  }
  getFiles(event) {
    this.files = event.target.files[0].name;
    return this.files;
  }
  onFileChange(fileInput: Event) {
    this.fileName = this.getFiles(event);
  }

  getRandomNumber() {
    const random = Math.floor(Math.random() * (999999 - 100000)) + 100000;
    return random;
  }

  getHookInstance(length) {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  createPatientResource() {
    this.patientId = this.getRandomNumber();
    var EthnicityCode = {
      system: 'http://hl7.org/fhir/v3/vs/Ethnicity',
      code: this.memberInfo.controls['ethnicity'].value,
      display: this.memberInfo.controls['ethnicity'].value
    };
    this.EthnicityObj = {
      url: this.Urlconstent + 'us-core-ethnicity',
      valueCodeableConcept: { coding: EthnicityCode }
    };
    this.extensionObj.push(this.EthnicityObj);

    var RaceCode = {
      system: 'http://hl7.org/fhir/v3/vs/Race',
      code: this.memberInfo.controls['race'].value,
      display: this.memberInfo.controls['race'].value
    };
    this.raceObj = {
      url: this.Urlconstent + 'us-core-race',
      valueCodeableConcept: { coding: RaceCode }
    };
    this.extensionObj.push(this.raceObj);

    const convertDate = this.datePipe.transform(
      this.memberInfo.controls['dob'].value,
      'yyyy-MM-dd'
    );
    const patientResource = {
      resourceType: 'Patient',
      id: this.patientId,
      identifier: [{ value: this.memberInfo.controls['memberId'].value }],
      name: [
        {
          family: this.memberInfo.controls['lname'].value,
          given: [this.memberInfo.controls['fname'].value]
        }
      ],
      address: [
        {
          line: [this.memberInfo.controls['patientaddress'].value],
          city: this.memberInfo.controls['city'].value,
          state: this.memberInfo.controls['state'].value,
          postalCode: this.memberInfo.controls['postalCode'].value
        }
      ],
      dateOfBirth: convertDate,
      extension: this.extensionObj
    };
    return patientResource;
  }

  createPractitionerResource() {
    this.practitionerId = this.getRandomNumber();
    const practitionerResource = {
      resourceType: 'Practitioner',
      id: this.practitionerId,
      name: [
        {
          family: this.reqProvider.controls['plastname'].value,
          given: [this.reqProvider.controls['pfirstname'].value]
        }
      ],
      address: [
        {
          line: [this.reqProvider.controls['address'].value],
          city: this.reqProvider.controls['city'].value,
          state: this.reqProvider.controls['state'].value,
          postalCode: this.reqProvider.controls['postalCode'].value
        }
      ]
    };
    return practitionerResource;
  }

  createOrganizationResource() {
    this.organizationId = this.getRandomNumber();
    const organizationResource = {
      resourceType: 'Organization',
      id: this.organizationId,
      name: this.selectedValues.Organization,
      alias: this.selectedValues.Payer
    };
    return organizationResource;
  }

  createLocationResource() {
    this.locationId = this.getRandomNumber();
    const locationResource = {
      resourceType: 'Location',
      id: this.locationId,
      name: this.organisationInfo.controls['orgPlaceOfSer'].value,
      address: [
        {
          line: [this.reqProvider.controls['address'].value],
          city: this.reqProvider.controls['city'].value,
          state: this.reqProvider.controls['state'].value,
          postalCode: this.reqProvider.controls['postalCode'].value
        }
      ]
    };

    return locationResource;
  }

  createProcedureObject() {
    this.procedureId = this.getRandomNumber();
    let procedureCode1 = [];
    // if (this.procedureCode.controls['proCode1'].value !== undefined) {
    //   procedureCode1 = this.procedureCode.controls['proCode1'].value.split('-');
    // }
    // let procedureCode2 = [];
    // if (this.procedureCode.controls['proCode2'].value !== undefined) {
    //   procedureCode2 = this.procedureCode.controls['proCode2'].value.split('-');
    // }
    // let procedureCode3 = [];
    // if (this.procedureCode.controls['proCode3'].value !== undefined) {
    //   procedureCode3 = this.procedureCode.controls['proCode2'].value.split('-');
    // }
    for (let i = 0; i < this.coding1.length; i++) {
      this.procudecodeMainItem.push(this.coding1[i].coding);
    }
    console.log(this.procudecodeMainItem);
    const procedureResource = {
      resourceType: 'Procedure',
      id: this.procedureId,
      code: {
        coding: this.procudecodeMainItem
        // coding: [
        //   {
        //     system: 'http://snomed.info/sct',
        //     code: procedureCode1[0],
        //     display: procedureCode1[1]
        //   },
        //   {
        //     system: 'http://snomed.info/sct',
        //     code: procedureCode2[0],
        //     display: procedureCode2[1]
        //   },
        //   {
        //     system: 'http://snomed.info/sct',
        //     code: procedureCode3[0],
        //     display: procedureCode3[1]
        //   }
        // ]
      }
    };
    return procedureResource;
  }

  createConditionResource() {
    this.conditionId = this.getRandomNumber();
    const conditionObject = {
      resourceType: 'Condition',
      id: this.conditionId,
      code: {
        coding: [
          {
            system: 'http://snomed.info/sct',
            code: this.getRandomNumber(),
            display: this.diagnosis.controls['diagnoCode'].value
          }
        ]
      }
    };
    return conditionObject;
  }

  createAppointmentResource() {
    this.appointmentId = this.getRandomNumber();
    const appointmentObject = {
      resourceType: 'Appointment',
      id: this.appointmentId,
      created: this.AppointmentInfo.controls['addmDate'].value,
      appointmentType: this.AppointmentInfo.controls['addmType'].value
    };
    return appointmentObject;
  }

  coverageResource() {
    this.coverageId = this.getRandomNumber();
    const coverageObject = {
      resourceType: 'Coverage',
      id: this.coverageId,
      class: [
        {
          type: {
            coding: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/coverage-class',
                code: this.coverageInfo.controls['groupId'].value
              }
            ]
          },
          value: this.coverageInfo.controls['value'].value
        }
      ],
      subscriberId: this.coverageInfo.controls['subId'].value,
      dependent: this.coverageInfo.controls['suffix'].value
    };
    return coverageObject;
  }

  coverageRequestResource() {
    this.coverageEligibilityRequestId = this.getRandomNumber();
    const coverageRequestObject = {
      resourceType: 'CoverageEligibilityRequest',
      id: this.coverageEligibilityRequestId,
      status: this.coverageInfo.controls['status'].value,
      purpose: [this.coverageInfo.controls['purpose'].value],
      patient: 'Patient/' + this.patientId,
      Provider: 'Practitioner/' + this.practitionerId,
      insurer: 'Organization/' + this.organizationId,
      facility: 'Location/' + this.locationId,
      // servicedDate: this.AppointmentInfo.controls['addmDate'].value,
      created: this.coverageInfo.controls['created'].value,
      item: [
        {
          detail: 'Procedure/' + this.procedureId,
          diagnosis: [
            {
              diagnosisReference: '6++/' + this.conditionId
            }
          ]
        }
      ],
      insurance: [
        {
          coverage: 'Coverage/' + this.coverageId
        }
      ]
    };
    return coverageRequestObject;
  }

  submitRequest() {
    const patientObject = this.createPatientResource();
    const practitionerObject = this.createPractitionerResource();
    const organizationObject = this.createOrganizationResource();
    const locationObject = this.createLocationResource();
    const procedureObject = this.createProcedureObject();
    const conditionObject = this.createConditionResource();
    const appointmentObject = this.createAppointmentResource();
    const coverageObject = this.coverageResource();
    const coverageRequestObject = this.coverageRequestResource();

    const requestObj = {
      hookInstance: this.getHookInstance(14),
      fhirServer: 'https://fhir.sitenv.org/open/fhir',
      context: {
        coverageEligibilityRequestId: coverageRequestObject.id,
        userId: 'Practitioner/' + practitionerObject.id,
        patientId: patientObject.id,
        organizationId: organizationObject.id,
        locationId: locationObject.id,
        procedureId: procedureObject.id,
        conditionId: conditionObject.id,
        appointmentId: appointmentObject.id,
        coverageId: coverageObject.id
      },
      prefetch: {
        coverageRequest: coverageRequestObject,
        crdPatient: patientObject,
        crdPractitioner: practitionerObject,
        crdOrganization: organizationObject,
        crdLocation: locationObject,
        crdProcedure: procedureObject,
        crdCondition: conditionObject,
        crdAppointment: appointmentObject,
        crdCoverage: coverageObject
      }
    };
    this.coverageEligibityRequestData = requestObj;

    console.log(this.coverageEligibityRequestData);
    console.log(JSON.stringify(this.coverageEligibityRequestData));

    this.AuthorizationService.postDate(
      this.coverageEligibityRequestData
    ).subscribe(data => {
      console.log(data.status);
      if (data.status === 200) {
        this.util.notify(
          'CRD-Request has been posted to CDS-Service Successfully!',
          'success',
          'Success'
        );
      }
    });
    this.openDialog();
  }
}
